// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_6J6","cls2":"ReferenceReportPage-cls2_cUA ReferenceReportPage-cls1_6J6"};